export { DEFAULT_DESKTOP_RECORDER_START_TIMEOUT_MS as RECORDER_START_TIMEOUT_MS } from '@/app-shell/flags/desktop-recorder-start-timeout';
export const RECORDING_START_TIMEOUT_ERROR_CODE = 'RECORDING_START_TIMEOUT';

export const isRecorderStartTimeout = (error: unknown) =>
  (error as { errorCode?: string } | null)?.errorCode ===
  RECORDING_START_TIMEOUT_ERROR_CODE;

/** HAR-1327: match mobile / offline / remote chunk contract when PostHog is absent. */
export const DESKTOP_CHUNK_INTERVAL_DEFAULT_SECS = 45;
/** Floor so PostHog can still roll back via the `"30"` multivariate variant. */
export const DESKTOP_CHUNK_INTERVAL_MIN_SECS = 30;

/**
 * Resolve the desktop online chunk-upload interval from a PostHog payload.
 * Missing / non-numeric / below-min values fall back to the 45s default.
 */
export function resolveDesktopChunkIntervalSecs(payload: unknown): number {
  const duration =
    payload !== null && typeof payload === 'object' && 'duration' in payload
      ? (payload as { duration: unknown }).duration
      : undefined;
  return typeof duration === 'number' && duration >= DESKTOP_CHUNK_INTERVAL_MIN_SECS
    ? duration
    : DESKTOP_CHUNK_INTERVAL_DEFAULT_SECS;
}

/**
 * `pTimeout` rejections carry this fixed message. Use only where the raced unit
 * contains no nested `pTimeout` of its own.
 */
export const isPTimeoutRejection = (error: unknown) =>
  error instanceof Error && error.message === 'promise timed out';
